import React, { useEffect, useRef, useState } from 'react';
import withBase from '../../hoc/withBase';

import axios from '../../axios';

import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardIcon from "../../components/Card/CardIcon.js";
import CardBody from '../../components/Card/CardBody';
import CardFooter from "../../components/Card/CardFooter.js";
import Danger from "../../components/Typography/Danger.js";

import styles from "../../assets/jss/material-dashboard-react/views/dashboardStyle";
import { makeStyles } from "@material-ui/core/styles";


import Person from "@material-ui/icons/Person";
import PeopleIcon from '@material-ui/icons/People';
import SimCardIcon from '@material-ui/icons/SimCard';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import SearchIcon from '@material-ui/icons/Search';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import { BACKEND } from '../../constants'

import { Link } from 'react-router-dom'

import palette from 'google-palette';
import DailyBillingsChart from './DailyBillingsChart';
import MonthlyBillingsChart from './MonthlyBillingsChart';
import SubscribersLogsChart from './SubscribersLogsChart';
import ActiveRegisteredChart from './ActiveRegisteredChart';
import { Button, Typography, TextField, InputAdornment, IconButton, Chip, Box, Collapse, Tabs, Tab } from '@material-ui/core';
import { capitalizeFirstLetter } from '../../helpers/helper';

const useStyles = makeStyles(styles);

function hexToRGBA(hex, opacity) {
    return 'rgba(' + (hex = hex.replace('#', '')).match(new RegExp('(.{' + hex.length / 3 + '})', 'g')).map(function (l) { return parseInt(hex.length % 2 ? l + l : l, 16) }).concat(isFinite(opacity) ? opacity : 1).join(',') + ')';

}
const createLegend = (allSoracomUsers) => {
    //This function creates the legend for all the soraocom Users that exist
    const colors = palette('tol-rainbow', Object.keys(allSoracomUsers).length);
    return allSoracomUsers.reduce((dict, user, idx) => ({ ...dict, [user.operatorId]: { ...user, color: hexToRGBA(colors[idx]), disabled: false } }), {})
}

const Dashboard = props => {
    const classes = useStyles();
    const [dashboardData, setDashboardData] = useState(null);
    const [allOperators, setAllOperators] = useState([]);
    const [sortedOperators, setSortedOperators] = useState([]);
    const [dailyBillings, setDailyBillings] = useState({});
    const [monthlyBillings, setMonthlyBillings] = useState([]);
    const [subscriberLogs, setSubscribersLogs] = useState([]);
    const [currentSubscriberStatus, setCurrentSubscriberStatus] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [legendSelection, setLegendSelection] = useState(true);

    // New state for improved legend
    const [searchTerm, setSearchTerm] = useState('');
    const [legendExpanded, setLegendExpanded] = useState(true);
    const [viewMode, setViewMode] = useState('top20'); // 'top20', 'all', 'custom'
    const [selectedCount, setSelectedCount] = useState(0);

    useEffect(() => {
        axios.get(BACKEND.DASHBOARD.uri)
            .then(response => {
                setDashboardData(response.data);
                setIsLoading(false);
            })
            .catch(err => {

            })
        async function fetchData() {
            const { data } = await axios.get(BACKEND.DASHBOARD_OPERATORS.uri);
            const legend = createLegend(data);
            setAllOperators(legend);
            setSortedOperators(data.map(operator => operator.operatorId));

            // Count initially selected
            const selected = Object.values(legend).filter(op => !op.disabled).length;
            setSelectedCount(selected);

            const { data: { dailyBillings } } = await axios.get(BACKEND.DASHBOARD_DAILY_BILLINGS.uri);
            setDailyBillings(dailyBillings);

            const { data: { monthlyUniqueBillings } } = await axios.get(BACKEND.DASHBOARD_MONTHLY_BILLINGS.uri);
            setMonthlyBillings(monthlyUniqueBillings);

            const { data: { subscribersLogs } } = await axios.get(BACKEND.DASHBOARD_SUBSCRIBERS_LOGS.uri);
            setSubscribersLogs(subscribersLogs);

            const { data: { subscribersStatus } } = await axios.get(BACKEND.DASHBOARD_CURRENT_SUBSCRIBER_STATUS.uri);
            setCurrentSubscriberStatus(subscribersStatus);
        }
        fetchData();
    }, [])

    // Filter operators based on search
    const filteredOperators = sortedOperators.filter(operatorId => {
        if (!allOperators[operatorId]) return false;
        const name = allOperators[operatorId].name.toLowerCase();
        return name.includes(searchTerm.toLowerCase()) || operatorId.includes(searchTerm);
    });

    // Get top 20 operators by subscriber count
    const getTopOperators = () => {
        const operatorsWithData = currentSubscriberStatus
            .map(status => ({
                ...status,
                total: (status.registered || 0) + (status.activated || 0)
            }))
            .sort((a, b) => b.total - a.total)
            .slice(0, 20)
            .map(s => s.operatorId);
        return operatorsWithData;
    };

    const displayOperators = viewMode === 'top20' ? getTopOperators() : filteredOperators;

    const handleSelectTop20 = () => {
        const top20 = getTopOperators();
        const tmp = { ...allOperators };
        Object.keys(tmp).forEach(opId => {
            tmp[opId].disabled = !top20.includes(opId);
        });
        setAllOperators(tmp);
        setViewMode('top20');
        setSelectedCount(top20.length);
    };

    const handleToggleOperator = (operatorId) => {
        const tmp = { ...allOperators };
        tmp[operatorId].disabled = !tmp[operatorId].disabled;
        setAllOperators(tmp);
        setSelectedCount(Object.values(tmp).filter(op => !op.disabled).length);
    };

    return (
        <>
            <GridContainer>

                <GridItem xs={12} sm={6} md={3}>
                    <Card>
                        <CardHeader color="success" stats icon>
                            <CardIcon color="success">
                                <PeopleIcon />
                            </CardIcon>
                            <p className={classes.cardCategory}>Soracom Users</p>
                            <h3 className={classes.cardTitle}>
                                {isLoading ? 'Loading...' : dashboardData.basicStats.soracomUserssCount}
                            </h3>
                        </CardHeader>
                        <CardFooter stats>
                            <div className={classes.stats}>
                                <Link to='/soracom-users' style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}>
                                    <PeopleIcon />
                                    Show Soracom Users
                                </Link>
                            </div>
                        </CardFooter>
                    </Card>
                </GridItem>

                <GridItem xs={12} sm={6} md={3}>
                    <Card>
                        <CardHeader color="success" stats icon>
                            <CardIcon color="success">
                                <SimCardIcon />
                            </CardIcon>
                            <p className={classes.cardCategory}>Subscribers(Active/Registered)</p>
                            <h3 className={classes.cardTitle}>
                                {isLoading ? 'Loading...' : dashboardData.basicStats.activeSubscribersCount}/{isLoading ? 'Loading...' : dashboardData.basicStats.subscribersCount}
                            </h3>
                        </CardHeader>
                        <CardFooter stats>
                            <div className={classes.stats}>
                                <Link to='/soracom-subscribers' style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}>
                                    <SimCardIcon />
                                    Show Soracom Subscribers
                                </Link>
                            </div>
                        </CardFooter>
                    </Card>
                </GridItem>

                <GridItem xs={12} sm={6} md={3}>
                    <Card>
                        <CardHeader color="success" stats icon>
                            <CardIcon color="success">
                                <Person />
                            </CardIcon>
                            <p className={classes.cardCategory}>Local Users</p>
                            <h3 className={classes.cardTitle}>
                                {isLoading ? 'Loading...' : dashboardData.basicStats.usersCount}
                            </h3>
                        </CardHeader>
                        <CardFooter stats>
                            <div className={classes.stats}>
                                <Link to='/users' style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}>
                                    <Person />
                                    Show Local Users
                                </Link>
                            </div>
                        </CardFooter>
                    </Card>
                </GridItem>

                <GridItem xs={12} sm={6} md={3}>
                    <Card>
                        <CardHeader color="success" stats icon>
                            <CardIcon color="success">
                                <LockOpenIcon />
                            </CardIcon>
                            <p className={classes.cardCategory}>Keepass Entries</p>
                            <h3 className={classes.cardTitle}>
                                {isLoading ? 'Loading...' : dashboardData.basicStats.keepassesCount}
                            </h3>
                        </CardHeader>
                        <CardFooter stats>
                            <div className={classes.stats}>
                                <Link to='/keepass' style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}>
                                    <LockOpenIcon />
                                    Show Keepass Entries
                                </Link>
                            </div>
                        </CardFooter>
                    </Card>
                </GridItem>

                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary">
                            <Box display="flex" alignItems="center" justifyContent="space-between">
                                <Box>
                                    <Typography variant="h6" style={{ color: '#fff', margin: 0 }}>
                                        Operator Selection
                                    </Typography>
                                    <Typography variant="body2" style={{ color: 'rgba(255,255,255,0.8)', margin: '4px 0 0 0' }}>
                                        {selectedCount} of {sortedOperators.length} operators selected
                                    </Typography>
                                </Box>
                                <IconButton
                                    size="small"
                                    onClick={() => setLegendExpanded(!legendExpanded)}
                                    style={{ color: '#fff' }}
                                >
                                    {legendExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                </IconButton>
                            </Box>
                        </CardHeader>
                        <Collapse in={legendExpanded}>
                            <CardBody>
                                <GridContainer>
                                    {/* Search and Quick Actions */}
                                    <GridItem xs={12} md={3}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            placeholder="Search operators..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SearchIcon fontSize="small" />
                                                    </InputAdornment>
                                                ),
                                            }}
                                            style={{ marginBottom: 12 }}
                                        />

                                        {/* Quick Actions */}
                                        <Box display="flex" gap={1} flexWrap="wrap" mb={2}>
                                            <Chip
                                                label="Top 20"
                                                size="small"
                                                color={viewMode === 'top20' ? 'primary' : 'default'}
                                                onClick={handleSelectTop20}
                                                clickable
                                            />
                                            <Chip
                                                label="Select All"
                                                size="small"
                                                onClick={() => {
                                                    const tmp = { ...allOperators };
                                                    Object.keys(tmp).forEach(opId => {
                                                        tmp[opId].disabled = false;
                                                    });
                                                    setAllOperators(tmp);
                                                    setViewMode('all');
                                                    setSelectedCount(Object.keys(tmp).length);
                                                }}
                                                clickable
                                            />
                                            <Chip
                                                label="Clear All"
                                                size="small"
                                                onClick={() => {
                                                    const tmp = { ...allOperators };
                                                    Object.keys(tmp).forEach(opId => {
                                                        tmp[opId].disabled = true;
                                                    });
                                                    setAllOperators(tmp);
                                                    setViewMode('custom');
                                                    setSelectedCount(0);
                                                }}
                                                clickable
                                            />
                                        </Box>

                                        {searchTerm && (
                                            <Typography variant="caption" color="textSecondary" display="block" mb={1}>
                                                Showing {displayOperators.length} of {sortedOperators.length} operators
                                            </Typography>
                                        )}
                                    </GridItem>

                                    {/* Operators List - 3 columns */}
                                    <GridItem xs={12} md={9}>
                                        <Box
                                            style={{
                                                maxHeight: '40vh',
                                                overflow: 'auto',
                                                display: 'grid',
                                                gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
                                                gap: '4px',
                                            }}
                                        >
                                            {displayOperators.length > 0 ? (
                                                <>
                                                    {displayOperators.map(operatorId => {
                                                        if (!allOperators[operatorId]) return null;
                                                        const operator = allOperators[operatorId];
                                                        const isSelected = !operator.disabled;
                                                        const displayName = capitalizeFirstLetter(
                                                            operator.name.replace('soracom_', '').replace('@thinxtra.com', '')
                                                        );

                                                        return (
                                                            <Box
                                                                key={operatorId}
                                                                onClick={() => handleToggleOperator(operatorId)}
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    padding: '6px 8px',
                                                                    cursor: 'pointer',
                                                                    borderRadius: '4px',
                                                                    transition: 'background-color 0.2s',
                                                                    border: '1px solid #f0f0f0',
                                                                }}
                                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                                            >
                                                                {isSelected ? (
                                                                    <CheckBoxIcon style={{ color: operator.color, marginRight: 6 }} fontSize="small" />
                                                                ) : (
                                                                    <CheckBoxOutlineBlankIcon style={{ color: '#ccc', marginRight: 6 }} fontSize="small" />
                                                                )}
                                                                <Box
                                                                    style={{
                                                                        width: 10,
                                                                        height: 10,
                                                                        backgroundColor: isSelected ? operator.color : 'transparent',
                                                                        border: `2px solid ${operator.color}`,
                                                                        borderRadius: 2,
                                                                        marginRight: 6,
                                                                        flexShrink: 0,
                                                                    }}
                                                                />
                                                                <Typography
                                                                    variant="body2"
                                                                    style={{
                                                                        fontSize: '0.8rem',
                                                                        opacity: isSelected ? 1 : 0.5,
                                                                        fontWeight: isSelected ? 500 : 400,
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                    }}
                                                                    title={displayName}
                                                                >
                                                                    {displayName}
                                                                </Typography>
                                                            </Box>
                                                        );
                                                    })}
                                                </>
                                            ) : (
                                                <Typography variant="body2" color="textSecondary" align="center" style={{ padding: 20, gridColumn: '1 / -1' }}>
                                                    {searchTerm ? 'No operators found' : 'Loading...'}
                                                </Typography>
                                            )}
                                        </Box>
                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                        </Collapse>
                    </Card>
                </GridItem>

                {/* Charts Section - Full Width */}
                <GridItem xs={12}>
                    <GridItem xs={12}>
                        <ActiveRegisteredChart legend={allOperators} currentSubscriberStatus={currentSubscriberStatus} />
                    </GridItem>
                    <GridItem xs={12}>
                        <Card>
                            <DailyBillingsChart legend={allOperators} dailyBillings={dailyBillings} />
                        </Card>
                    </GridItem>
                    <GridItem xs={12}>
                        <Card>
                            <MonthlyBillingsChart legend={allOperators} monthlyBillings={monthlyBillings} />
                        </Card>
                    </GridItem>
                </GridItem>
                <GridItem xs={12}>
                    <SubscribersLogsChart legend={allOperators} subscriberLogs={subscriberLogs} />
                </GridItem>
            </GridContainer >
        </>

    )
}

export default withBase(Dashboard);
